import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { MaterialLoader } from 'components/loaders'
import styles from './button.styl'

export default class Button extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    isLoading: PropTypes.bool,
    secondary: PropTypes.bool,
    disabled: PropTypes.bool,
    anchor: PropTypes.bool,
    fluid: PropTypes.bool,
    link: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    intlKey: PropTypes.string,
    type: PropTypes.string,
    to: PropTypes.string,
    style: PropTypes.object,
    compact: PropTypes.bool
  }

  static defaultProps = {
    type: 'submit',
    disabled: false,
    onClick: () => {},
    isLoading: false,
    className: 'btn',
    style: {}
  }

  renderContent = () => {
    const { isLoading = false, children, secondary, intlKey } = this.props

    return (
      <span>
        <div className={`${styles.content} ${isLoading ? styles.loading : ''}`}>
          {intlKey
            ? <FormattedMessage
                id={intlKey}
                defaultMessage={typeof children === 'string' ? children : ''}
            />
            : children}
        </div>
        {isLoading &&
          <div className={styles.loader}>
            <MaterialLoader white={!secondary} small />
          </div>}
      </span>
    )
  }

  render() {
    const {
      className,
      disabled,
      onClick,
      type = 'submit',
      secondary,
      anchor,
      isLoading,
      fluid,
      link,
      to,
      style,
      compact
    } = this.props

    const classNames = [styles.btn, className]

    secondary && classNames.push(styles.secondary)
    disabled && classNames.push(styles.disabled)
    anchor && classNames.push(styles.anchor)
    fluid && classNames.push(styles.fluid)
    compact && classNames.push(styles.compact)
    isLoading && classNames.push(styles.isLoading)

    return link
      ? <Link
          className={classNames.join(' ')}
          to={to}
          style={style}
      >
        {this.renderContent()}
      </Link>
      : <button
          type={type}
          className={classNames.join(' ')}
          onClick={onClick}
          disabled={disabled}
          style={style}
      >
        {this.renderContent()}
      </button>
  }
}
